import { render, staticRenderFns } from "./ArticleShareSettings.vue?vue&type=template&id=a0ecf74c&"
import script from "./ArticleShareSettings.vue?vue&type=script&lang=ts&"
export * from "./ArticleShareSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleShareSettings.vue?vue&type=style&index=0&id=a0ecf74c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports